
import Papa from 'papaparse';

/**
 * Converts an array of objects to a CSV string and triggers a download.
 * @param {Array<Object>} data The data from the grid (e.g., appState.w2Data).
 * @param {string} filename The desired name for the downloaded file (e.g., 'w2-export.csv').
 */
export function exportDataAsCsv(data, filename) {
  if (!data || data.length === 0) {
    alert("There is no data to export.");
    return;
  }

  const csv = Papa.unparse(data);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
